if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        this.submitButton = document.getElementById(this.dataset.submitButtonId);
        if (!this.submitButton) return;

        this.barButton = this.querySelector('.sora-sticky-atc__button');
        this.barButton.addEventListener('click', () => {
          if (this.submitButton.disabled) return;
          this.submitButton.click();
        });

        this.syncState();
        this.mutationObserver = new MutationObserver(() => this.syncState());
        this.mutationObserver.observe(this.submitButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        this.intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            const belowViewport = entry.boundingClientRect.top < 0;
            this.classList.toggle('sora-sticky-atc--visible', !entry.isIntersecting && belowViewport);
            this.setAttribute('aria-hidden', entry.isIntersecting || !belowViewport);
          },
          { threshold: 0 }
        );
        this.intersectionObserver.observe(this.submitButton);
      }

      disconnectedCallback() {
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
      }

      syncState() {
        const label = this.submitButton.querySelector('span');
        if (label && this.barButton.querySelector('span')) {
          this.barButton.querySelector('span').textContent = label.textContent.trim();
        }
        this.barButton.disabled = this.submitButton.disabled;
      }
    }
  );
}
